import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { CHAT_MENU_WIDTH } from '@components/Chat/constants';
import { clsx, colorSet } from '@components/Provider';

interface Props {
  height?: number;
}

const PurchaseOrderFixedBottomCTA: React.FC<Props> = ({ children, height }) => {
  const isDashboard = window.location.pathname.includes('/dashboard');
  const classes = useStyles();
  return (
    <>
      <div style={{ height: height }} className={clsx(classes.block)}></div>
      <div
        style={{ height: height }}
        className={clsx(classes.fixed, { isDashboard })}
      >
        {children}
      </div>
    </>
  );
};

export default PurchaseOrderFixedBottomCTA;

const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    visibility: 'hidden',
    width: '100%',
    minHeight: 88,
    maxWidth: '100%'
  },
  fixed: {
    bottom: 0,
    padding: '20px 24px',
    width: '100%',
    minHeight: 88,
    position: 'fixed',
    maxWidth: `calc(100% - ${CHAT_MENU_WIDTH + 1}px)`,
    borderTop: `1px solid ${colorSet.gray400}`,
    backgroundColor: colorSet.gray000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '&.isDashboard': {
      width: 'calc(100% - 375px)'
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      padding: 16,
      '&.isDashboard': {
        width: '100%'
      }
    }
  }
}));
